import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { TweenMax, Quint } from 'gsap';
import * as moment from 'moment';
import { FilterTypePeriod } from '../models/filter-type-period.enum';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { EventTypes } from '../../../shared/EventTypes';

@Component({
	selector: 'app-filter-period',
	templateUrl: './filter-period.component.html',
	styleUrls: ['./filter-period.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PixFilterPeriodComponent implements OnInit {
	@Output() onSelectedCustomPeriod: EventEmitter<any> = new EventEmitter<any>();
	@Input() filterSelected = FilterTypePeriod.NONE;
	public formPeriod: FormGroup;
	public periodOpened = false;
	public dateBeginError = false;
	public dateEndError = false;


	constructor(private route: ActivatedRoute, private router: Router, private formBuilder: FormBuilder) {
		this.formPeriod = formBuilder.group({
			'dateBegin': [null, Validators.required],
			'dateEnd': [null, Validators.required]
		});
	}

	ngOnInit() { }

	setFilterSelected(filter: FilterTypePeriod) {
		this.filterSelected = filter;
		this.resolveFilterSelected();
	}

	resolveFilterSelected() {
		switch (this.filterSelected) {
			case FilterTypePeriod.TODAY:
				this.loadToday();
				this.closePeriod();
				break;
			case FilterTypePeriod.BIWEEKLY:
				this.loadHalfMonth();
				this.closePeriod();
				break;
			case FilterTypePeriod.MONTHLY:
				this.loadFullMonth();
				this.closePeriod();
				break;
			case FilterTypePeriod.CUSTOM:
				this.openPeriod();
				break;
			default:
				this.closePeriod();
				break;
		}
	}

	sendSelectedDate(dateBegin: Date, dateEnd: Date): void {
		this.onSelectedCustomPeriod.emit({
			dateBegin: dateBegin,
			dateEnd: dateEnd
		});
	}

	loadToday() {
		const dateBegin = new Date();

		this.sendSelectedDate(dateBegin, null);
	}

	loadHalfMonth() {
		const dateBegin = new Date(new Date().setDate(new Date().getDate() - 14));

		this.sendSelectedDate(dateBegin, null);
	}

	loadFullMonth() {
		const dateBegin = new Date(new Date().setDate(new Date().getDate() - 29));

		this.sendSelectedDate(dateBegin, null);
	}

	openPeriod = () => this.periodOpened = true;
	closePeriod = () => this.periodOpened = false;

	onSubmit() {
		this.dateBeginError = this.formPeriod.controls.dateBegin.invalid;
		this.dateEndError = this.formPeriod.controls.dateEnd.invalid;

		if (this.formPeriod.valid) {
			if (moment(this.formPeriod.controls.dateBegin.value).isSameOrBefore(this.formPeriod.controls.dateEnd.value)) {
				this.dateBeginError = false;
				this.dateEndError = false;
				this.closePeriod();

				const dateBegin = this.formPeriod.value.dateBegin;
				const dateEnd = this.formPeriod.value.dateEnd;
				this.sendSelectedDate(dateBegin, dateEnd);

			} else {
				this.dateEndError = true;
				this.dateBeginError = true;
				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: 'A data inicial, deve ser menor que a data final.' });
			}
		}
	}

	changeDate() {

		if (!this.formPeriod.controls.dateBegin.valid) {
			this.dateBeginError = true;
		} else {
			this.dateBeginError = false;
		}

		if (!this.formPeriod.controls.dateEnd.valid) {
			this.dateEndError = true;
		} else {
			this.dateEndError = false;
		}

	}

	public get filterTypePeriod(): typeof FilterTypePeriod {
		return FilterTypePeriod;
	}

	public removeWeekend = (d: Date): boolean => {
		const day = d.getDay();
		return day !== 0 && day !== 6 ;
	}
}




// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/filter-period/filter-period.component.ts